import React, { useState, useEffect } from 'react'
import * as moment from 'moment';
import { useHistory } from 'react-router-dom';
import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import { imageDisplay, pickupRequest, rejectRequest, updateReceivedClaimMessage } from 'redux/actions/myClaims';
import AcceptPopup from '../AcceptPopup';
import Button from 'web/components/Button';
import AlertModal from 'web/components/AlertModal';
import { FORMAT } from 'web/components/utils/dateOfBirthValidation';
import { useDispatch, useSelector } from 'react-redux';
import BolUploadModal from 'web/components/BolUploadModal';
import { updateClaimReuploadBOL } from 'redux/actions/myOrders';
import {
  Heading,
  TrackDetail,
  TrackBox,
  NoRecordFound,
  TrackBoxAction,
  Auth,
  BoxWrapperNew,
  DescriptionBox,
  HeaderSection,
  CenterBox,
  ChatBtn,
} from "./trackDetailTypeOneStyled";
import PdfDocument from './RAFormPdfDocument'
import { Container } from "web/components/ChatBox/ChatBoxStyled";
import UploadDummy from '../../../../../assets/images/UploadDummy.png'
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import RightArrowLight from "web/assets/images/right-arrow-sell.png";
import ChatIcon from 'web/assets/svg/ChatIcon'
import axioPath from '../../../../../../api/axioPath';
import { fetchLanguageContentNew } from 'redux/actions/language';
import { Tooltip } from 'reactstrap';
import information from "web/assets/images/informationIcon.png";
import ChatboxComponent from './chatboxComponent';
import MessageCountComponent from './MessageCountChatBoxComponent'
import { downloadFile } from 'redux/actions/helper/downloadFile';

const TrackDetailTypeOne = ({ response, claimType, callBackFun, chatOpenOrderId }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const [acceptState, setAcceptState] = useState(false)
  const [rejectState, setRejectState] = useState(false)
  const [chatOpen, setChatOpen] = useState(null)
  const [chatMessage, setChatMessage] = useState('')
  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()
  const [acceptArrBoth, setAcceptArrBoth] = useState([])
  const [acceptArrQuantityDeliver, setAcceptArrQuantityDeliver] = useState([])
  const [acceptArrQuantityPickup, setAcceptArrQuantityPickup] = useState([])
  const [acceptArrQuality, setAcceptArrQuality] = useState([])
  const [acceptArrBOL, setAcceptArrBOL] = useState([])
  const [rejectArr, setRejectArr] = useState([])
  const [modalBOL, setModalBOL] = useState(false);
  const [chatMessageList, setchatMessageList] = useState([])
  const toggleBOLModal = () => setModalBOL(!modalBOL);

  useEffect(() => {
    if (chatOpenOrderId !== undefined) setChatOpen(chatOpenOrderId)
  }, [])

  useEffect(() => {
    if (languageContentNew?.Resolution_Center_Page) setPageLanguageContents(languageContentNew.Resolution_Center_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  useEffect(() => {
    setAcceptArrQuality([
      {
        value: 'pickUp',
        label: pageLanguageContents?.ClaimContents[0]?.ExchangePallets,
      },
      {
        value: 'away',
        label: pageLanguageContents?.ClaimContents[1]?.PickupPallets,
      },
      {
        value: 'other',
        label: pageLanguageContents?.ClaimContents[2]?.KeepPallets,
      },
      {
        value: 'Admin',
        label: pageLanguageContents?.ClaimContents[3]?.ContactAdmin,
      },
    ])
    setAcceptArrQuantityDeliver([
      {
        value: 'pickUp',
        label: pageLanguageContents?.ClaimContents[44]?.ExchangePalletsQuantity,
      },
      {
        value: 'other',
        label: pageLanguageContents?.ClaimContents[45]?.KeepPalletsQuantity,
      },
      {
        value: 'Admin',
        label: pageLanguageContents?.ClaimContents[3]?.ContactAdmin,
      },
    ])
    setAcceptArrQuantityPickup([
      {
        value: 'pickUp',
        label: pageLanguageContents?.ClaimContents[49]?.ExchangePalletsQuantityPickup,
      },
      {
        value: 'other',
        label: pageLanguageContents?.ClaimContents[45]?.KeepPalletsQuantity,
      },
      {
        value: 'Admin',
        label: pageLanguageContents?.ClaimContents[3]?.ContactAdmin,
      },
    ])
    setAcceptArrBoth([
      {
        value: 'pickUp',
        label: pageLanguageContents?.ClaimContents[46]?.ExchangePalletsBoth,
      },
      {
        value: 'away',
        label: pageLanguageContents?.ClaimContents[47]?.PickupPalletsBoth,
      },
      {
        value: 'other',
        label: pageLanguageContents?.ClaimContents[48]?.KeepPalletsBoth,
      },
      {
        value: 'Admin',
        label: pageLanguageContents?.ClaimContents[3]?.ContactAdmin,
      },
    ])
    setAcceptArrBOL([
      {
        value: 'bol',
        label: 'Reupload BOL/POD.',
      },
      {
        value: 'Admin',
        label: pageLanguageContents?.ClaimContents[3]?.ContactAdmin,
      },
    ])
    setRejectArr([
      {
        value: 'Quantity',
        label: pageLanguageContents?.ClaimContents[4]?.Quantity,
        comment: pageLanguageContents?.ClaimContents[8]?.DontAgree,
      },
      {
        value: 'Quality',
        label: pageLanguageContents?.ClaimContents[5]?.Quality1,
        comment: pageLanguageContents?.ClaimContents[9]?.NotMine,
      },
      {
        value: 'QualityNotSupported',
        label: pageLanguageContents?.ClaimContents[6]?.Quality2,
        comment: pageLanguageContents?.ClaimContents[10]?.NoEvidence,
      },
      {
        value: 'Other',
        label: pageLanguageContents?.ClaimContents[7]?.Other,
        comment: pageLanguageContents?.ClaimContents[7]?.Other,
      },
    ])
  }, [pageLanguageContents])

  const [tooltip, settTooltip] = useState(false);
  const [tooltipSection, setTooltipSection] = useState('');
  const iIconToolTip = (infoSection, infoTxt) => {
    return <>
      <img
        id={infoSection}
        src={information}
        style={{
          position: "relative",
          top: "-2px",
        }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltip && tooltipSection === infoSection}
        target={infoSection}
        toggle={() => {
          settTooltip(!tooltip)
          setTooltipSection(tooltipSection === '' ? infoSection : '')
        }
        }
      >
        {infoTxt}
      </Tooltip>
    </>
  }

  const [acceptPopupResponse, setAcceptPopupResponse] = useState(
    {
      id: '',
      orderId: '',
      issueType: '',
      pricePerPallet: '',
      totalPalletQuality: '',
      totalPalletQuantity: '',
      deliveryType: ''
    }
  )

  const [rejectPopupResponse, setRejectPopupResponse] = useState(
    {
      value: '',
      comment: '',
    }
  )

  const [acceptPopupModal, setAcceptPopupModal] = useState(false);
  const acceptPopupToggleModal = () => setAcceptPopupModal(!acceptPopupModal);

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const [alertType, setAlertType] = useState('');
  const toggleModal = () => setModal(!modal);
  const [title, setTitle] = useState('');
  const [selectOrderId, setSelectOrderId] = useState("")

  const generatePdfDocument = async (e, documentData) => {
    const blob = await pdf((
      <PdfDocument
        pdfDocumentData={documentData}
      />
    )).toBlob();
    saveAs(blob, 'RAForm');
  };

  const [acceptRadioState, setAcceptRadioState] = useState()
  const token = localStorage.getItem('token');

  const [itemArr, setItemArr] = useState({ items: [] })
  const [indexState, setIndexState] = useState(0)

  const [setTimer, setTimerState] = useState(false);


  useEffect(() => {
    const intervalCall = setInterval(() => {

      messageCountApi()


    }, 3000);
    return () => clearInterval(intervalCall)
  }, [])

  const messageCountApi = async () => {
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/');
      toggleModal();
    } else {
      const token = localStorage.getItem('token');
      // let locationId = localStorage.getItem("locationID")
      // let buyerLocationId, sellerLocationID
      // if(item.order?.buyerInfo?.locationsId){
      //     let buyerLocationIdTemp = item.order?.buyerInfo?.locationsId?.filter(val => val == locationId)
      //     if (buyerLocationIdTemp?.length > 0) buyerLocationId = item.order?.buyerInfo?.locationsId?.toString() 
      //   }
      //   else{
      //     if(item.order?.buyerInfo?.locationId === locationId) buyerLocationId = item.order?.buyerInfo?.locationId
      //   }

      //   if(item.order?.sellerInfo?.locationsId){
      //               let sellerLocationIdTemp = item.order?.sellerInfo?.locationsId?.filter(val => val == locationId)
      //       if (sellerLocationIdTemp?.length > 0) sellerLocationID = item.order?.sellerInfo?.locationsId?.toString()
      //   }
      //   else{
      //     if(item.order?.sellerInfo?.locationId === locationId) sellerLocationID = item.order?.sellerInfo?.locationId
      //   }

      //   let data = {
      //     userAuth: buyerLocationId ? buyerLocationId : sellerLocationID ? sellerLocationID : '',
      //     userType: buyerLocationId ? 'BUYER' : sellerLocationID ? 'SELLER' : '',
      //     orderId: item.orderId,        
      //     claimId: item.id,

      //   }

      //   let response = await dispatch(chatMessageCount(data, token));
      // setChatCount(response.unreadMsgCount)

    }
  }

  useEffect(() => {
    let arr = [];
    for (let i = 0; i < response.length; i++) {
      let obj = {
        id: response[i].id,
        orderId: response[i].orderId,
        flag: false,
        value: '',
        rejectflag: false,
      }
      arr.push(obj)
      if (i === response.length - 1) {
        setItemArr({ items: arr })
      }
    }

    setTimeout(
      () => {
        if (response && response.length === 0)
          setTimerState(true)
      },
      4000
    );
  }, []);
  const acceptCreditHandler = async () => {
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/');
      toggleModal();
    } else {
      let data =
      {
        id: "608bcfdc54cd246db9bfbaad",
        orderId: "OD161977538536",
        returnInstruction: "Old Pallets",
        returnPickUpDate: "2021-04-30",
        isPickedUpIssuesPallet: true  // when seller want to pick up pallets  otherwise false
      }

      let response = await dispatch(pickupRequest(data, token));
      if (response.status === 'SUCCESS') {
        if (response.payload.length !== 0) {
        }
      } else {
        if (response.statusCode === 401) {
          history.push('/sign-in')
          window.location.reload(false);
        } else {

        }
      }
    }
  }
  const rejectHandler = async (item) => {
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/');
      toggleModal();
    } else {
      let data =
      {
        id: item.id,
        orderId: item.orderId,
        issueType: rejectPopupResponse.value,
        comments: rejectPopupResponse.comment,
      }

      let response = await dispatch(rejectRequest(data, token));
      if (response.status === 'SUCCESS') {
        setTitle("Escalate to PT Admin")
        setModalContent(`Thank you for contacting us!
        The PalletTrader administrator will get back to you within the next business day.`);
        setModalLink('');
        toggleModal();
        setAlertType('escalatedClaim')
      } else {
        if (response.statusCode === 401) {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
        }
      }
    }
  }

  const acceptRadio = (item, index) => {
    let setIndex = index;
    let acceptArrTemp = []
    let acceptArr = []
    let resolvedWithExchange = false
    let issueList = ['QUALITY', 'QUANTITY', 'BOTH']
    if (item.actionTakenForExchange && item.order && item.order.claimDetails && item.order.claimDetails.length > 0 && item.order.claimDetails[item.order.claimDetails.length - 1].returnInstruction && (item.order.claimDetails[item.order.claimDetails.length - 1].returnInstruction.includes('Exchange') || item.order.claimDetails[item.order.claimDetails.length - 1].returnInstruction.includes('Redeliver'))) {
      resolvedWithExchange = true
    }
    if (item.issueType === 'QUALITY') acceptArrTemp = acceptArrQuality
    else if (item.issueType === 'QUANTITY' && item.addressType === 'DELIVERABLE') acceptArrTemp = acceptArrQuantityDeliver
    else if (item.issueType === 'QUANTITY' && item.addressType === 'PICKUP') acceptArrTemp = acceptArrQuantityPickup
    else if (item.issueType === 'BOTH') acceptArrTemp = acceptArrBoth
    else acceptArrTemp = acceptArrBOL

    acceptArr = JSON.parse(JSON.stringify(acceptArrTemp))
    // if ((item.order?.achOrderPayments && item.order?.paymentStatusDetails?.paymentStatus !== 'ACH_CAPTURED') && issueList.includes(item.issueType)) acceptArr = acceptArr.filter((val, index) => index !== 0)
    if (item.orderId?.toLowerCase().includes('exchange') && issueList.includes(item.issueType)) acceptArr = acceptArr.filter((val, index) => index !== 0)
    return (
      <>
        <TrackBox
          style={{
            borderTop: "solid 1px #c5c5c5",
            marginTop: "15px",
            paddingTop: "15px",
          }}
        >
          <HeaderSection
            style={{
              marginBottom: "8px",
            }}
          >
            <p>{pageLanguageContents?.ClaimContents[11]?.ClaimResolution}</p>
          </HeaderSection>
          <BoxWrapperNew>
            <div className="row m-0" style={{ opacity: resolvedWithExchange ? '0.5' : '1' }}>
              {acceptArr &&
                acceptArr.map((value, index) => (
                  <div className="col-md-6 p-0" key={index}>
                    <div className="radioField">
                      <label className="radio-container">
                        {acceptArr[index].label}
                        <input
                          name={"acceptRadio" + setIndex}
                          type="radio"
                          value={acceptArr[index].value} // could be something else for output?
                          disabled={resolvedWithExchange}
                          checked={(resolvedWithExchange && index === 0) ? true :
                            (itemArr.items[setIndex].value === acceptArr[index].value)
                          }
                          defaultValue={itemArr.items[setIndex].value}
                          onChange={() => { }}
                          onClick={(e) => {
                            setAcceptRadioState(e.target.value);

                            let newArr = [...itemArr.items]; // copying the old datas array
                            newArr[setIndex].value = e.target.value;
                            if (e.target.value === "Admin") {
                              setItemArr({ items: newArr });
                              setAcceptPopupResponse({
                                ...acceptPopupResponse,
                                id: item.id,
                                orderId: item.orderId,
                              });
                              setRejectState(true);
                              rejectHandler(item);
                            } else if (e.target.value === "bol") {
                              setItemArr({ items: newArr });
                              setAcceptPopupResponse({
                                ...acceptPopupResponse,
                                id: item.id,
                                orderId: item.orderId,
                              });
                              toggleBOLModal()
                            } else {
                              setItemArr({ items: newArr });
                              setAcceptPopupResponse({
                                ...acceptPopupResponse,
                                id: item.id,
                                orderId: item.orderId,
                                issueType: item.issueType,
                                pricePerPallet: item.pricePerPallet,
                                totalPalletQuality: item.totalPalletQuality,
                                totalPalletQuantity: item.totalPalletQuantity,
                                deliveryType: item.addressType
                              });
                              acceptPopupToggleModal();
                            }
                          }}
                          onBlur={() => { }}
                        />
                        <span className="radio-checkmark"></span>
                      </label>
                    </div>
                    {acceptArr[index].label === 'Contact PT Admin to Escalate Claim' &&
                      iIconToolTip('EscaltedClaimInfo', 'By choosing this option, it will move this claim to an escalated status and you will need to work with a PT Administrator to resolve.')}
                  </div>
                ))}
              <p>Have a question? Use the general chat button on the bottom right of your screen to contact a PT support admin, or call&nbsp;
                <span style={{ display: 'inline-block' }}>1-877-777-7495</span> for assistance.</p>
            </div>
          </BoxWrapperNew>
        </TrackBox>
      </>
    );
  }

  const rejectRadio = (item, index) => {
    let setIndex = index;
    return <>{itemArr.items[index].rejectflag && <div className='row mx-0 radioOption '>
      <div className='col-12 '>
        <div className='text-left'>
          <p style={{ marginBottom: '14px', marginRight: '15px' }}>
            {pageLanguageContents?.ClaimContents[12]?.Question1}</p>
        </div>
        <div className='d-flex flex-wrap'>
          {rejectArr &&
            rejectArr.map((value, index) => (
              <div className='mr-5' key={index}>
                <div className='radioField'>
                  <label className='radio-container'>
                    {rejectArr[index].label}
                    <input
                      name={'acceptRadio' + setIndex}
                      type='radio'
                      value={rejectArr[index].value} // could be something else for output?
                      checked={itemArr.items[setIndex].value === rejectArr[index].value}
                      defaultValue={itemArr.items[setIndex].value}
                      onChange={() => { }}
                      onClick={(e) => {
                        setAcceptRadioState(e.target.value)
                        let newArr = [...itemArr.items]; // copying the old datas array
                        newArr[setIndex].value = e.target.value;
                        newArr[index].flag = true;
                        newArr[index].rejectflag = false;
                        setItemArr({ items: newArr })

                        setRejectPopupResponse({
                          value: e.target.value,
                          comment: e.target.comment,
                        })
                      }}
                      onBlur={() => { }}
                    />
                    <span className='radio-checkmark'></span>
                  </label>
                </div>

              </div>
            ))}

        </div>
      </div>

      <div className="submitAction">
        <Button
          type='app-green-button submitBtn'
          disabled={!itemArr.items[setIndex].value && true}
          handleClick={() => {
            rejectHandler(item)
          }}>
          {pageLanguageContents?.ClaimContents[13]?.Submit}
        </Button>
      </div>

    </div>}</>
  }

  const [imgResponse, setImgResponse] = useState(undefined);

  const imageUpload = async (imagePath) => {
    let response = await dispatch(imageDisplay(imagePath, token));
    // const fileUrl = process.env.REACT_APP_API_URL + '/order/image/' + imagePath;
    // window.open(fileUrl);
    dispatch(downloadFile(imagePath));
  }

  // const postMessage = (index) => {
  //   const token = localStorage.getItem("token")
  //   const authId = localStorage.getItem("authId")
  //   let url = 'order/claim/adminResolutionThread'
  //   let data = {
  //     "id": response[index].id,
  //     "orderId": response[index].orderId,
  //     "message": chatMessage,
  //     "name": localStorage.getItem("userName"),
  //     "userType": authId == response[index].claimRaisedAuthId ? "Buyer" : "Seller",
  //     "isPrivate": false,
  //     "messageSentAuthId": authId,
  //     "toBuyer": false,
  //     "toSeller": false
  //   }
  //   let orderId = response[index].orderId
  //   if (chatMessage !== '') {
  //     axioPath.post(url, data, {
  //       headers: {
  //         Authorization: token
  //       },
  //     }).then((response) => {
  //       setChatMessage('')
  //       callBackFun('Escalated', orderId, 'skipLoading');
  //     }).catch((ex) => {
  //     });
  //   }
  // }

  const callUpdateBOL = async (status, values) => {
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/');
      toggleModal();
    } else {
      let formData = new FormData();
      let data
      data = {
        id: acceptPopupResponse.id,
        orderId: acceptPopupResponse.orderId,
      }
      formData.append('request', JSON.stringify(data))
      formData.append('file', values.bolDocument)
      let response = await dispatch(updateClaimReuploadBOL(formData, token));

      if (response.status === 'SUCCESS') {
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
        setAlertType('reuploadBol')
      } else {
        if (response.statusCode === 401) {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
        }
      }
    }
  }

  const updatefetchApiForChatMessage = async (item) => {
    const token = localStorage.getItem('token');

    let locationId = localStorage.getItem("locationID")
    let buyerLocationId, sellerLocationID
    if (item.order?.buyerInfo?.locationsId) {
      let buyerLocationIdTemp = item.order?.buyerInfo?.locationsId?.filter(val => val == locationId)
      if (buyerLocationIdTemp?.length > 0) buyerLocationId = item.order?.buyerInfo?.locationsId?.toString()
    }
    else {
      if (item.order?.buyerInfo?.locationId === locationId) buyerLocationId = item.order?.buyerInfo?.locationId
    }

    if (item.order?.sellerInfo?.locationsId) {
      let sellerLocationIdTemp = item.order?.sellerInfo?.locationsId?.filter(val => val == locationId)
      if (sellerLocationIdTemp?.length > 0) sellerLocationID = item.order?.sellerInfo?.locationsId?.toString()
    }
    else {
      if (item.order?.sellerInfo?.locationId === locationId) sellerLocationID = item.order?.sellerInfo?.locationId
    }


    let data = {
      userAuth: buyerLocationId ? buyerLocationId : sellerLocationID ? sellerLocationID : '',
      userType: buyerLocationId ? 'BUYER' : sellerLocationID ? 'SELLER' : '',
      claimId: item.id,
      orderId: item.orderId,
      admin: "demo"
    }
    let response = await dispatch(updateReceivedClaimMessage(data, token));
    if (response && response.status === 'SUCCESS') {
      setchatMessageList(response?.payload?.msg)
    } else {
      if (response.statusCode === 401) {
        history.push('/sign-in')
        window.location.reload(false);
      }
    }
  }

  const toggleFunction = () => {
    setSelectOrderId("")
  }

  return (
    <>
      {itemArr && itemArr.items.length !== 0 ? (
        <>
          {response.map((item, index) => {
            const { adminResolutionThread } = item
            let chatNotificationCount = 0
            if (adminResolutionThread !== null) {
              chatNotificationCount = adminResolutionThread.filter(val => (val.readByBuyer !== null && !(val.readByBuyer || val.readBySeller))).length
            }
            return (
              <TrackDetail key={index}>
                <Heading>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2>{item.orderId}</h2>
                    {claimType === "receivedClaim" && item.isPickedUpIssuesPallet && item.returnPickUpDate &&
                      <p className="colorfull" style={{ marginRight: '20px', color: 'red', width: '100%', marginLeft: '20px', textAlign: 'end' }}>Seller to Pickup Pallets on {moment(item.returnPickUpDate).format(FORMAT)}</p>
                    }

                    {/*  recent chat related codes, dont delete it */}
                    <Container style={{ display: "flex", justifyContent: "flex-end", marginRight: '', position: 'relative', width: "100%" }}>
                      <div style={{ marginRight: "20px" }}>
                        {item.claimStatus !== "ADMIN_RESOLVED" &&
                          <>
                            {(item.claimStatus === "REJECTED" || item.adminResolutionClaimDetails !== null) &&

                              <ChatBtn
                                onClick={() => {
                                  setSelectOrderId(item.orderId)
                                  setTimeout(
                                    () => {
                                      updatefetchApiForChatMessage(item)
                                    },
                                    4000
                                  );

                                }}
                              >
                                <ChatIcon />

                                Contact Admin
                                {selectOrderId != item.orderId &&
                                  <MessageCountComponent item={item} />
                                }
                              </ChatBtn>
                            }
                          </>
                        }
                      </div>

                      {item.claimStatus !== "ADMIN_RESOLVED" && selectOrderId == item.orderId &&
                        <>
                          {(item.claimStatus === "REJECTED" || item.adminResolutionClaimDetails !== null) &&
                            <ChatboxComponent item={item} responseValue={response} toggleFunction={toggleFunction} chatMessageListValue={chatMessageList} />
                          }
                        </>
                      }
                    </Container>



                    {/* temporarily commenting the chat related codes, dont delete it */}
                    {/* <ChatboxComponent/> */}
                    {/* {(item.claimStatus === "REJECTED" ||
                      item.adminResolutionClaimDetails !== null) &&
                      <BoxWrapperNew style={{ width: 'auto !important' }}>
                        <div style={{ display: "flex", justifyContent: "flex-end", marginRight: '20px', position: 'relative' }}>
                          {(item.claimStatus === "REJECTED" ||
                            item.adminResolutionClaimDetails !== null) && (
                              <ChatBtn
                                onClick={() => {
                                  if (item.adminResolutionThread && item.adminResolutionThread.length !== 0) {
                                    let authId = localStorage.getItem("authId")
                                    let userType
                                    if (authId === response[index].claimRaisedAuthId) userType = "Buyer"
                                    else userType = "Seller"
                                    axioPath.post(`/order/claim/messageThread/update?threadId=${item.id}&userType=${userType}&readOf=admin`, {}, {
                                      headers: {
                                        Authorization: token
                                      }
                                    })
                                  }
                                  if (chatOpen === null) {
                                    setChatOpen(item.orderId);
                                  } else {
                                    callBackFun('Escalated');
                                    setChatOpen(null);
                                  }
                                }}
                              >
                                <ChatIcon />
                                {chatNotificationCount > 0 && (
                                  <div style={{ height: '22px', width: '22px', borderRadius: '11px', background: '#0a1f30', top: '-20px', position: 'relative', left: '138px' }}>
                                    <span title={`${chatNotificationCount} unread messages`} style={{ position: 'relative', left: '6px', color: 'white' }}>
                                      {chatNotificationCount}
                                    </span>
                                  </div>
                                )}
                                {pageLanguageContents?.ClaimContents[40]?.Chat}
                              </ChatBtn>
                            )}
                          {chatOpen === item.orderId && (
                            <RaisedClaimChatBox>
                              <ChatHeader>
                                <ChatUserIcon color="#fff" />
                                <h6>
                                  {pageLanguageContents?.ClaimContents[41]?.MessageThreads}
                                </h6>
                                <ChatCloseIcon
                                  className="close-icon"
                                  onClick={() => {
                                    callBackFun('Escalated');
                                    if (chatOpen === null) setChatOpen(item.orderId);
                                    else setChatOpen(null);
                                  }}
                                />
                              </ChatHeader>


                              <div style={{ maxHeight: "400px", overflow: "auto", display: 'flex', flexDirection: 'column-reverse' }}>
                                <div>
                                  {item.adminResolutionThread &&
                                    item.adminResolutionThread
                                      .filter((val) => val.isPrivate === false)
                                      .map((val, index) => {
                                        let prevDay = index > 0 ? moment.unix(item.adminResolutionThread.filter((val) => val.isPrivate === false)[index - 1].created).format('ll') : ''
                                        let currentDay = moment.unix(val.created).format('ll')
                                        let today = moment().format('ll')
                                        let yesterday = moment().subtract(1, 'days').format('ll')
                                        return (
                                          <ChatboxBody>
                                            {val.userType === "Admin" ? (
                                              <>
                                                {prevDay !== currentDay &&
                                                  <div style={{ position: 'sticky', top: '0px', textAlign: 'center', zIndex: '2', margin: '5px' }}>
                                                    <div style={{ margin: 'auto', position: 'absolute', width: '100%', borderTop: '1px solid gray', top: '9px' }}></div>
                                                    <p style={{ margin: 'auto', zIndex: '3', background: '#fff' }}>{currentDay === today ? "Today" : currentDay === yesterday ? "Yesterday" : currentDay}</p>
                                                  </div>
                                                }
                                                <div className="admin">
                                                  <IconWrapper>
                                                    <ChatUserIcon color="#6d7b69" />
                                                    <p>{val.userType}</p>
                                                  </IconWrapper>
                                                  <Chatbox>
                                                    <ChatText>
                                                      <p>{val.message}</p>
                                                    </ChatText>
                                                    <TimeStamp>
                                                      {moment.unix(val.created).format('h:mm a')}
                                                    </TimeStamp>
                                                  </Chatbox>
                                                </div>
                                              </>
                                            ) : val.userType === "Buyer" ? (
                                              <>
                                                {prevDay !== currentDay &&
                                                  <div style={{ position: 'sticky', top: '0px', textAlign: 'center', zIndex: '2', margin: '5px' }}>
                                                    <div style={{ margin: 'auto', position: 'absolute', width: '100%', borderTop: '1px solid gray', top: '9px' }}></div>
                                                    <p style={{ margin: 'auto', zIndex: '3', background: '#fff' }}>{currentDay === today ? "Today" : currentDay === yesterday ? "Yesterday" : currentDay}</p>
                                                  </div>
                                                }
                                                <div className="buyer">
                                                  <Chatbox>
                                                    <ChatText>
                                                      <p>{val.message}</p>
                                                    </ChatText>
                                                    <TimeStamp>
                                                      {moment.unix(val.created).format('h:mm a')}
                                                    </TimeStamp>
                                                  </Chatbox>
                                                  <IconWrapper>
                                                    <ChatUserIcon color="#0a5587" />
                                                    <p>{val.userType}</p>
                                                  </IconWrapper>
                                                </div>
                                              </>
                                            ) : (
                                                  <>
                                                    {prevDay !== currentDay &&
                                                      <div style={{ position: 'sticky', top: '0px', textAlign: 'center', zIndex: '2', margin: '5px' }}>
                                                        <div style={{ margin: 'auto', position: 'absolute', width: '100%', borderTop: '1px solid gray', top: '9px' }}></div>
                                                        <p style={{ margin: 'auto', zIndex: '3', background: '#fff' }}>{currentDay === today ? "Today" : currentDay === yesterday ? "Yesterday" : currentDay}</p>
                                                      </div>
                                                    }
                                                    <div className="seller">
                                                      <Chatbox>
                                                        <ChatText>
                                                          <p>{val.message}</p>
                                                        </ChatText>
                                                        <TimeStamp>
                                                          {moment.unix(val.created).format('h:mm a')}
                                                        </TimeStamp>
                                                      </Chatbox>
                                                      <IconWrapper>
                                                        <ChatUserIcon color="#87cdf1" />
                                                        <p>{val.userType}</p>
                                                      </IconWrapper>
                                                    </div>
                                                  </>
                                                )}
                                          </ChatboxBody>
                                        );
                                      })}
                                </div>
                              </div>
                              {item.claimStatus === "REJECTED" && (
                                <TextAreaWrapper>
                                  <textarea
                                    style={{ width: "100%" }}
                                    value={chatMessage}
                                    rows="1"
                                    placeholder={pageLanguageContents?.ClaimContents[42]?.TypeMsg}
                                    onChange={(e) =>
                                      setChatMessage(e.target.value)
                                    }
                                  />
                                  <ChatEnterIcon
                                    style={{ opacity: chatMessage !== '' ? '1' : '0.5' }}
                                    onClick={() => postMessage(index)}
                                  />
                                </TextAreaWrapper>
                              )}
                            </RaisedClaimChatBox>
                          )}
                        </div>
                      </BoxWrapperNew>
                    } */}
                  </div>
                  {/* {localStorage.getItem('accountType')}--{claimType} */}
                  {claimType === "raiseClaim" ? <img
                    src={RightArrow}
                    alt="RightArrow"
                    className="right-arrow"
                  /> : <img
                    src={RightArrowLight}
                    alt="RightArrow"
                    className="right-arrow"
                  />
                  }
                  {claimType === "pendingClaim" && <img
                    src={RightArrowLight}
                    alt="RightArrow"
                    className="right-arrow"
                  />}
                  {claimType === "receivedClaim" && <>
                    {item.claimReceivedOrRaised === "Raised" ? <img
                      src={RightArrow}
                      alt="RightArrow"
                      className="right-arrow"
                    /> : <> {item.postType === "LOAD" ?// && (localStorage.getItem('accountType') === 'Buyer' || localStorage.getItem('accountType') === 'Both')
                      <>{item.claimReceivedOrRaised === "Received" ?
                        <img
                          src={RightArrowLight}
                          alt="RightArrow"
                          className="right-arrow"
                        /> : <img
                          src={RightArrow}
                          alt="RightArrow"
                          className="right-arrow"
                        />}</> : <img
                        src={RightArrowLight}
                        alt="RightArrow"
                        className="right-arrow"
                      />}</>}
                  </>}
                </Heading>
                <DescriptionBox>
                  <div>
                    <TrackBox>
                      <HeaderSection>
                        <p className="mt-0">{pageLanguageContents?.ClaimContents[14]?.ClaimDetails}</p>
                      </HeaderSection>
                      <div>
                        <CenterBox>
                          {item.poNumber && (
                            <div>
                              <p className="colorfull"> PO# </p>
                              <p>{item.poNumber}</p>
                            </div>
                          )}
                          <div>
                            <p className="colorfull">{pageLanguageContents?.ClaimContents[15]?.ClaimDate} </p>
                            {item.claimRaisedUserType === "raiseClaim" && (
                              <p>
                                {item.claimDateBuyerSide
                                  ? moment(item.claimDateBuyerSide).format(FORMAT)
                                  : moment(
                                    item.shippingStatusDetails &&
                                    item.shippingStatusDetails[1]
                                      .createdBuyerTime
                                  ).format(FORMAT)}
                              </p>
                            )}
                            {item.claimRaisedUserType !== "raiseClaim" && (
                              <p>
                                {item.claimDateSellerSide
                                  ? moment(item.claimDateSellerSide).format(
                                    FORMAT
                                  )
                                  : moment(
                                    item.shippingStatusDetails &&
                                    item.shippingStatusDetails[1]
                                      .createdSellerTime
                                  ).format(FORMAT)}
                              </p>
                            )}
                          </div>

                          <div>
                            <p className="colorfull"> {pageLanguageContents?.ClaimContents[16]?.ClaimType} </p>
                            {item.issueType === "BOTH" ? (
                              <p>{pageLanguageContents?.ClaimContents[17]?.Quality_Quantity}</p>
                            ) : (
                              <p>{item.issueType}</p>
                            )}
                          </div>
                          {(item.issueType === "QUALITY" || item.issueType === "BOTH" || item.issueType === "QUANTITY") &&
                            <div>
                              <p className="colorfull">{pageLanguageContents?.ClaimContents[18]?.ClaimQuantity}</p>
                              {item.issueType === "QUANTITY" && (
                                <p>{item.totalPalletQuantity} Missing Qty</p>
                              )}
                              {item.issueType === "QUALITY" && (
                                <p>{item.totalPalletQuality} Quality</p>
                              )}
                              {item.issueType === "BOTH" && (
                                <p>{` [${item.totalPalletQuality} Quality], [${item.totalPalletQuantity} Missing Qty] `}</p>
                              )}
                            </div>
                          }
                          <div>
                            <p className="colorfull">{pageLanguageContents?.ClaimContents[23]?.DiscprepancyDetails}</p>
                            {item.comments ? <p style={{ wordBreak: 'break-all', marginRight: '2px' }}> {item.comments}</p> : <p></p>}
                          </div>
                        </CenterBox>
                        <CenterBox>
                          {(item.issueType === "QUALITY" || item.issueType === "BOTH" || item.issueType === "QUANTITY") &&
                            <div>
                              <p className="colorfull">{pageLanguageContents?.ClaimContents[19]?.ClaimAmount}</p>
                              <p>$ {item.claimTotalPrice && item.claimTotalPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                          }
                          {(item.issueType === "QUALITY" || item.issueType === "BOTH") &&
                            <div>
                              <p className="colorfull">{pageLanguageContents?.ClaimContents[20]?.QualityType}</p>
                              {item.typeOfIssues && item.typeOfIssues.length > 0 &&
                                <p>{item.typeOfIssues.includes('EXPOSED_NAILS') && (item.typeOfIssues.length > 1 ? 'Exposed Nails, ' : 'Exposed Nails')}
                                  {item.typeOfIssues.includes('BROKEN_BOARD') && (item.typeOfIssues.includes('MISSING_BOARDS') || item.typeOfIssues.includes('OTHER') ? 'Broken Boards, ' : 'Broken Boards')}
                                  {item.typeOfIssues.includes('MISSING_BOARDS') && (item.typeOfIssues.includes('OTHER') ? 'Missing Boards, ' : 'Missing Boards')}
                                  {item.typeOfIssues.includes('OTHER') && 'Other'}</p>
                              }
                            </div>
                          }

                          {(item.issueType === "QUALITY" || item.issueType === "BOTH") &&
                            item.images.length !== 0 && (
                              <div>
                                <p className="colorfull">{pageLanguageContents?.ClaimContents[21]?.Images_Docs}</p>
                                {item.images.map((value, index) => (
                                  <p
                                    className="upload"
                                    onClick={() => {
                                      imageUpload(item.images[index]);
                                    }}
                                  >
                                    <img
                                      style={{ marginRight: "5px" }}
                                      src={UploadDummy}
                                      alt="upload Dummy"
                                    />
                                    {item.images[index]}
                                  </p>
                                ))}
                              </div>
                            )
                          }
                        </CenterBox>
                      </div>
                    </TrackBox>

                    {claimType === "receivedClaim" &&
                      <TrackBox
                        style={{
                          borderTop: "solid 1px #c5c5c5",
                          marginTop: "15px",
                          paddingTop: "15px",
                        }}
                      >
                        <HeaderSection>
                          <p>{pageLanguageContents?.ClaimContents[22]?.ResolutionDetails} </p>
                        </HeaderSection>
                        <div>
                          <CenterBox>
                            {claimType === "receivedClaim" &&
                              <div>
                                <p className="colorfull">Resolution Type:</p>
                                {item.issueType === "BOL" ? <p>BOL/POD Updated</p> :
                                  (item.claimStatus !== 'REJECTED' && !item.adminResolutionClaimDetails) ? <p>{item.resolutionMessage}</p> : <p>Claim Escalated to Admin</p>}
                              </div>
                            }
                            {claimType === "receivedClaim" && item.issueType != "BOL" && item.claimStatus !== 'REJECTED' && !item.adminResolutionClaimDetails &&
                              <div>
                                <p className="colorfull">Seller Comments:</p>
                                {item.sellerComment ? <p style={{ wordBreak: 'break-all', marginRight: '2px' }}> {item.sellerComment}</p> : <p></p>}
                              </div>
                            }

                          </CenterBox>
                          <CenterBox>
                            {claimType === "receivedClaim" && (
                              <>
                                <div>
                                  <p className="colorfull">{pageLanguageContents?.ClaimContents[24]?.ClaimStatus}</p>
                                  <p>{item.claimStatus !== 'REJECTED' ? item.claimStatus : 'Escalated'}</p>
                                  {item.adminResolutionClaimDetails && (
                                    <>
                                      {item.adminResolutionClaimDetails.action === "DISCOUNT" ? (
                                        <div>
                                          {item.isSellerDiscounted ? (
                                            <p>${item.sellerDiscountedAmount} has been discounted</p>
                                          ) : (
                                            <p>${item.adminResolutionClaimDetails.discountAmount} has been discounted</p>
                                          )}
                                        </div>
                                      ) : (
                                        <div>
                                          {item.adminResolutionClaimDetails.action === "CANCEL_WITH_FEE" ? (
                                            <p>
                                              {pageLanguageContents?.ClaimContents[25]?.AdminCancel}
                                              <span>
                                                ({pageLanguageContents?.ClaimContents[26]?.WithFee} ${" "}
                                                {
                                                  item.adminResolutionClaimDetails.cancelFee
                                                }
                                                )
                                              </span>
                                            </p>
                                          ) : (
                                            <p>
                                              {pageLanguageContents?.ClaimContents[25]?.AdminCancel}
                                              <span>{pageLanguageContents?.ClaimContents[27]?.WithoutFee}</span>
                                            </p>
                                          )}
                                        </div>
                                      )}
                                    </>
                                  )}
                                </div>
                                {item.issueType != "BOL" && item.claimStatus !== 'REJECTED' && !item.adminResolutionClaimDetails &&
                                  <div>
                                    <p className="colorfull">{item.isPickedUpIssuesPallet ? 'Pick Up Date:' : pageLanguageContents?.ClaimContents[28]?.RedeliveryDate} </p>
                                    <p>
                                      {item.returnPickUpDate &&
                                        moment(item.returnPickUpDate).format(
                                          FORMAT
                                        )}
                                    </p>
                                  </div>
                                }
                              </>
                            )}
                          </CenterBox>
                        </div>
                      </TrackBox>
                    }

                    <TrackBox
                      style={{
                        borderTop: "solid 1px #c5c5c5",
                        marginTop: "15px",
                        paddingTop: "15px",
                      }}
                    >
                      <HeaderSection>
                        <p>{pageLanguageContents?.ClaimContents[29]?.LoadDetails}</p>
                      </HeaderSection>
                      <BoxWrapperNew>
                        <CenterBox>
                          <div>
                            <p className="colorfull">{pageLanguageContents?.ClaimContents[30]?.PostTitle} </p>
                            <p>{item.postTitle}</p>
                          </div>
                          <div>
                            <p className="colorfull">{pageLanguageContents?.ClaimContents[31]?.PostType} </p>
                            <p>{item.postType === 'LOAD' ? 'Need' : 'Inventory'}</p>
                          </div>
                          <div>
                            <p className="colorfull">Material, Condition:</p>
                            <p>{item?.order && item?.order?.orderDetails && item?.order?.orderDetails?.material}, {item?.order && item?.order?.orderDetails && item?.order?.orderDetails?.material === 'OTHER' ? 'NA' : item?.order && item?.order?.orderDetails && item?.order?.orderDetails?.condition && item?.order?.orderDetails?.condition.length > 0 && item?.order?.orderDetails?.condition[0]}&nbsp;
                              {item?.newConditionType && (item?.newConditionType === "HARDWOOD" ? '(HW)' : '(SW)')} </p>
                          </div>
                          <div>
                            <p className="colorfull">{pageLanguageContents?.ClaimContents[32]?.Grade}</p>
                            {item?.order && item?.order?.orderDetails && (item?.order?.orderDetails?.material === 'OTHER' || item?.order?.orderDetails?.material === 'PLASTIC') ?
                              <p>{'NA'}, {item?.order && item?.order?.orderDetails && item?.order?.orderDetails?.dimension && `${item?.order?.orderDetails?.dimension?.length} x ${item?.order?.orderDetails?.dimension?.width} x ${item?.order?.orderDetails?.dimension?.height}`}, {'NA'}</p>
                              :
                              // <p>{item.commodity && item.commodity.commodityName},{item.grade && item.grade.sizeWiseGrad ? item.grade.sizeWiseGrad : 'NA'}, {item.grade && item.grade.gradeName ? item.grade.gradeName : 'NA'}</p>
                              <p>{item?.commodity && item?.commodity?.commodityName},{item?.grade && item?.grade?.gradeName} {item?.order?.orderDetails?.dimension?.height &&
                                item?.order?.orderDetails?.dimension.length +
                                "x" +
                                item?.order?.orderDetails?.dimension?.width +
                                "x" +
                                item?.order?.orderDetails?.dimension?.height},{item?.grade && item?.grade?.sizeWiseGrad ? item?.grade?.sizeWiseGrad : 'NA'}</p>
                            }
                          </div>
                          <div>
                            <p className="colorfull">{pageLanguageContents?.ClaimContents[33]?.OfferedPrice}</p>
                            <p>$ {item.pricePerPallet.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                          </div>
                          <div>
                            <p className="colorfull">Total Cost:</p>
                            <p>$ {(item.pricePerPallet * item.quantity).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                          </div>
                        </CenterBox>
                        <CenterBox>
                          <div>
                            <p className="colorfull">{pageLanguageContents?.ClaimContents[34]?.ShipmentDate}</p>
                            {item.claimRaisedUserType === "raiseClaim" && (
                              <p>
                                {item.shippingStatusDetails &&
                                  moment(
                                    item.shippingStatusDetails[0].createdBuyerTime
                                  ).format(FORMAT)}
                              </p>
                            )}
                            {item.claimRaisedUserType !== "raiseClaim" && (
                              <p>
                                {item.shippingStatusDetails &&
                                  moment(
                                    item.shippingStatusDetails[0]
                                      .createdSellerTime
                                  ).format(FORMAT)}
                              </p>
                            )}
                          </div>
                          <div>
                            {item.rescheduleOrder ? (
                              <>
                                <p className="colorfull">{pageLanguageContents?.ClaimContents[35]?.RescheduledDate} </p>
                                {item.claimRaisedUserType === "raiseClaim" && (
                                  <p>
                                    {moment(
                                      item.rescheduleOrder.buyerRescheduledDate
                                    ).format(FORMAT)}
                                  </p>
                                )}
                                {item.claimRaisedUserType !== "raiseClaim" && (
                                  <p>
                                    {moment(
                                      item.rescheduleOrder.sellerRescheduledDate
                                    ).format(FORMAT)}
                                  </p>
                                )}
                              </>
                            ) : (
                              <>
                                <p className="colorfull">{item.addressType === 'DELIVERABLE' ? pageLanguageContents?.ClaimContents[36]?.DeliveryDate : 'Pickup Date'} </p>
                                {item.claimRaisedUserType === "raiseClaim" && (
                                  <p>
                                    {item.shippingStatusDetails &&
                                      moment(
                                        item.shippingStatusDetails[1]
                                          .createdBuyerTime
                                      ).format(FORMAT)}
                                  </p>
                                )}
                                {item.claimRaisedUserType !== "raiseClaim" && (
                                  <p>
                                    {item.shippingStatusDetails &&
                                      moment(
                                        item.shippingStatusDetails[1]
                                          .createdSellerTime
                                      ).format(FORMAT)}
                                  </p>
                                )}
                              </>
                            )}
                          </div>
                          <div>
                            <p className="colorfull">{pageLanguageContents?.ClaimContents[37]?.Quantity1}</p>
                            <p>{item.quantity}</p>
                          </div>
                        </CenterBox>
                      </BoxWrapperNew>
                      <BoxWrapperNew>
                        <CenterBox>
                          <div>
                            <p className="colorfull">{pageLanguageContents?.ClaimContents[38]?.SellerInfo}</p>
                            <p>
                              {item?.shipFrom && item?.shipFrom.name}&nbsp;<span></span>
                              {item?.shipFrom && item?.shipFrom.line1}&nbsp;{item?.shipFrom && item?.shipFrom.line2 && <span></span>}
                              {item?.shipFrom && item?.shipFrom.line2}&nbsp;<span></span>
                              {item?.shipFrom && item?.shipFrom.city.trim()},&nbsp;{item?.shipFrom && (stateConvert(item?.shipFrom?.state) || item?.shipFrom?.state)}&nbsp;{item.shipFrom && item.shipFrom.zip}
                            </p>
                          </div>
                        </CenterBox>
                        <CenterBox>
                          <div>
                            <p className="colorfull">Delivery/Pickup Location:</p>
                            <p>
                              {item.shipTo && item.shipTo.name}&nbsp;<span></span>
                              {item.shipTo && item.shipTo.line1}&nbsp;{item.shipTo && item.shipTo.line2 && <span></span>}
                              {item.shipTo && item.shipTo.line2}&nbsp;<span></span>
                              {item.shipTo && item.shipTo.city.trim()},&nbsp;{item.shipTo && (stateConvert(item.shipTo.state) || item.shipTo.state)}&nbsp;{item.shipTo && item.shipTo.zip}
                            </p>
                          </div>
                        </CenterBox>
                      </BoxWrapperNew>
                    </TrackBox>

                    {item.claimStatus === "PENDING" && claimType === "pendingClaim" && <>
                      <TrackBoxAction key={index}>
                        {acceptRadio(item, index)}
                      </TrackBoxAction>
                    </>}

                    {/* In case where seller choose to exchange or redeliver pallets and order not delievered yet, this section is to show buyer the action taken by the seller */}
                    {item.claimStatus === "PENDING" && claimType === "raiseClaim" && item.actionTakenForExchange &&
                      item.order && item.order.claimDetails && item.order.claimDetails.length > 0 && item.order.claimDetails[item.order.claimDetails.length - 1].returnInstruction && (item.order.claimDetails[item.order.claimDetails.length - 1].returnInstruction.includes('Exchange') || item.order.claimDetails[item.order.claimDetails.length - 1].returnInstruction.includes('Redeliver')) &&
                      <>
                        <TrackBox
                          style={{ borderTop: "solid 1px #c5c5c5", marginTop: "15px", paddingTop: "15px", }}
                        >
                          <HeaderSection>
                            <p>Seller Action</p>
                          </HeaderSection>
                          <p>Seller has decided to {item.order.claimDetails[item.order.claimDetails.length - 1].returnInstruction}.</p>
                        </TrackBox>
                      </>}

                    {item.issueType === "BOL" && claimType === "receivedClaim" && <>
                      <TrackBoxAction key={index}>
                        <TrackBox
                          style={{
                            borderTop: "solid 1px #c5c5c5",
                            marginTop: "15px",
                            paddingTop: "15px",
                          }}
                        >
                          <button
                            onClick={() => {
                              imageUpload(item.order.fileBOL);
                            }}
                          >
                            View Updated BOL/POD
                          </button>
                        </TrackBox>
                      </TrackBoxAction>
                    </>}
                    {/*
                      {(claimType !== "receivedClaim" && claimType !== "raiseClaim") && (
                        <Auth
                          style={{ cursor: "pointer" }}
                          onClick={(e) => generatePdfDocument(e, item)}
                        >
                          <span>
                            <LocalOfferOutlinedIcon />
                          </span>{" "}
                          {pageLanguageContents?.ClaimContents[43]?.RAForm}{" "}
                        </Auth>
                      )} */}

                  </div>
                </DescriptionBox>
              </TrackDetail>
            )
          })}
        </>
      ) : (
        <>{setTimer && <NoRecordFound></NoRecordFound>}</>
      )}

      {acceptPopupResponse.id !== "" && (
        <AcceptPopup
          isOpen={acceptPopupModal}
          toggle={acceptPopupToggleModal}
          title=""
          onClickHander={(obj) => { }}
          content=""
          acceptPopupResponse={acceptPopupResponse}
          acceptRadioState={acceptRadioState}
          callBackAccept={(val) => {
            setAcceptState(false);
            setRejectState(false);
            callBackFun(val);
          }}
          link="/"
        />
      )}

      <BolUploadModal
        isOpen={modalBOL}
        toggle={toggleBOLModal}
        title={''}
        content=''
        link='/'
        callBackBOL={(document) => {
          callUpdateBOL("DELIVERED", document);
        }}
        uploadType='claimReUpload'
        selectedItem=''
      />

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
        alertType={alertType}
        callBackAlert={() => {
          if (alertType === 'reuploadBol') {
            setAcceptState(false);
            setRejectState(false);
            callBackFun('Resolved');
          } else if (alertType === 'escalatedClaim') {
            callBackFun("Rejected");
          }
        }}
      />
    </>
  );
};

export default TrackDetailTypeOne;
